var _style, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 8 17",
    style: {
      enableBackground: "new 0 0 8 17"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M7.5,0.6c0,0.1,0,0.1,0,0.1c0,0.8,0,1.6,0,2.4c0,0.1,0,0.1-0.1,0.1c-0.4,0-0.9,0-1.3,0c-0.1,0-0.3,0-0.4,0.1 C5.3,3.4,5.1,3.7,5.1,4c0,0.6,0,1.1,0,1.7c0,0.1,0.1,0.1,0.1,0.1h2.3L7.2,8.5H5v0.2l0,7.5c0,0,0,0.1,0,0.1H2.1l0-0.1V8.5h-2 c0-0.1,0-0.1,0-0.1c0-0.8,0-1.6,0-2.4c0-0.1,0-0.1,0.1-0.1c0.6,0,1.1,0,1.7,0c0.1,0,0.1,0,0.1-0.2c0-0.7,0-1.5,0-2.2 c0-0.5,0.1-1,0.4-1.5C2.8,1.4,3.2,1,3.7,0.9c0.3-0.1,0.6-0.1,1-0.2l0.1,0L7.5,0.6L7.5,0.6z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.7c907816b12ba3b8a17c7e2aed04e591.svg";
export { ForwardRef as ReactComponent };